import React, { useEffect } from "react";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import { SET_AUDIT_PROPERTIES_DATA, TOGGLE_NOTIFICATION_DATE_WARNING_POPUP } from "./reducers/audit-properties-reducer"
import MdaeButton from "../../common_components/common_widgets/button";
import { useDispatch, useSelector } from "react-redux";
import { SET_AUDIT_ROUND_DATA, SET_CURRENT_ROUND_DATA } from "./reducers/external-audit-reducer";
import { isEqual } from "lodash";
import { convertDate, convertDateFormat, getFutureDateFromDays } from "../../utils/dateUtils";

export const toggleNotificationDateWarningPopup = (isVisible, dispatch) => {
  dispatch({
    type: TOGGLE_NOTIFICATION_DATE_WARNING_POPUP,
    data: {
      isNotificationDateWarningPopupVisible: isVisible
    },
  });
}


const NotificationDateWarningPopup: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const processTemplateRoundList = useSelector(
    (state) =>
      state["externalAuditReducer"].processTemplateRoundList,
    isEqual
  );

  let auditPropertiesData = useSelector(
    (state: any) => state.auditPropertiesReducer.auditPropertiesData,
    isEqual
  );
  const getPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          props.onCancelNotificationDateWarning();
          toggleNotificationDateWarningPopup(false, dispatch);
        }}
      >
        Warning
      </MdaePopupTitle>
    );
  };
  return (
    <div>
      <MdaePopup
        deferRendering={false}
        width={400}
        height={200}
        className="-warning-popup"
        mdaeTitleRender={getPopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_NOTIFICATION_DATE_WARNING_POPUP,
            reducerName: "auditPropertiesReducer",
            widgetOptionBindings: {
              visible: "isNotificationDateWarningPopupVisible",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div className="message-section">
                  This will update the round one submission deadline and related tasks. Do you want to continue?
                </div>
              </MdaePopupContent>
            </div>
          )
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupSecondaryButton"}
                  role={"secondary"}
                  onClick={() => {
                    props.onCancelNotificationDateWarning();
                    toggleNotificationDateWarningPopup(false, dispatch);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                <MdaeButton
                  id={"pnlNotificationDateWarningPopupPrimaryButton"}
                  role={"primary"}
                  onClick={() => {
                    let filteredItem = processTemplateRoundList?.filter(x => x.sequenceNo == 1);
                    dispatch({
                      type: SET_CURRENT_ROUND_DATA,
                      data: {
                        eaAuditRound: {
                          index: 0,
                          submissionDeadlineDate: convertDateFormat(getFutureDateFromDays(filteredItem[0]?.totalDays, auditPropertiesData?.notificationDate ? auditPropertiesData?.notificationDate : auditPropertiesData?.startDate))
                        },
                      },
                    });
                    dispatch({
                      type: SET_AUDIT_PROPERTIES_DATA,
                      data: {
                        auditPropertiesData: {
                          hasNotificationDateChanged: true
                        },
                      },
                    });
                    toggleNotificationDateWarningPopup(false, dispatch);
                  }}
                >
                  Ok
                </MdaeButton>
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          )
        }}
      >

      </MdaePopup>
    </div>
  )

}

export default NotificationDateWarningPopup;